<template>
  <div class="sharePanel">
    <div class="sharePanel-main">
      <div class="sharePanel-title">
        <p>— 分享3个人以上成功几率更高哦～快去邀请好友吧！—</p>
      </div>
      <div class="sharePanel-ways">
        <ul class="sharePanel-list">
          <li v-for="item in shareWays" :key="item.way"
            :class="['sharePanel-item', `sharePanel-item-${item.way}`]"
            @click="handleShare(item.way)"
          >
            <div></div><!-- 分享图标 -->
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
      <div class="sharePanel-cancel" @click="hidePanel">取消</div>
    </div>

    <van-popup v-model="isShowContentPopup" class="x-van-popup sharePanel-popup">
      <span class="sharePanel-popup-close" @click="closeContentPopup('contentPopup')"></span>
      <h3>面对面扫码</h3>
      <p>扫码领取新人专享200元优惠券</p>
      <img :src="shareData.qrcode" alt="小程序二维码">
    </van-popup>
    <!-- End: 分享内容展示。（二维码）图片 等 -->
    <HandleShare ref="handleShare" :shareConfig="shareConfig" :appVersion="appVersion" :userId="shareData.userId" />
    <!-- End：微信分享链接引导弹窗 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HandleShare from './HandleShare'
import { mixin_qrcode_miniProgram, mixin_shareData } from '../mixin/mixin'

export default {
  name: 'sharePanel',
  components: { HandleShare },
  computed: mapState(['userInfo']),
  mixins: [mixin_qrcode_miniProgram, mixin_shareData],
  props: {
    // 分享引导语
    SharePrompt: {
      type: String,
      default: ''
    },
    tutorId: {
      type: String,
      default: ''
    }
  },
  watch: {
    qrcode_miniProgram (value) {
      this.shareData.qrcode = value
    }
  },
  data () {
    return {
      // app中微信分享时的类型 // iOS 分享小程序功能8.8（20200824） 版本后才发布。需做兼容分享h5 链接
      appVersion: 0,
      isShowContentPopup: false,
      isShowLinkMaskForWX: false,
      shareWays: [
        { way: 'poster', name: '海报分享' },
        { way: 'qrcode', name: '面对面' }
      ],
      isApp: /jzh$/i.test(navigator.userAgent), // 是否是原生app
      isWX: /MicroMessenger/i.test(navigator.userAgent),
      isIOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent)
    }
  },
  created () {
    // 设置面对面扫码
    this.setQRCode(3)
    if (this.isApp) {
      // 获取当前app版本。判断ios版本号，是否支持分享小程序
      const deviceInfo = JSON.parse(xesApp.deviceInfo())
      this.appVersion = Number(deviceInfo.appVersionNumber)
      // app环境添加微信分享按钮
      // this.shareWays.unshift({ way: 'timeline', name: '微信朋友圈' })
      this.shareWays.unshift({ way: 'wechat', name: '微信好友' })
    }
    if (this.isWX) {
      // a微信环境添加微信分享按钮
      this.shareWays.unshift({ way: 'wechat', name: '微信好友' })
    }
  },
  methods: {
    // 取消按钮点击通知父组件去隐藏
    hidePanel () {
      this.$emit('panelDisplay', false)
    },
    // 分享方式点击
    handleShare (way) {
      this.$emit('shareClick', { way })
      this.$xesLogger.clickMsg({ params: { clickid: '3.2.1', action: 'handleShare', way } })
      // 登录失败sharelink为空 吊起登陆窗口
      if (!this.shareConfig.link) return this.$emit('shareErr', { code: 404, data: 'link' })
      // 跳转海报分享
      if (way === 'poster') { // 分享海报跳转
        let route = { name: 'savePoster' }
        if (this.tutorId) { // 辅导老师带新活动需要携带tutorId
          route = { name: 'savePoster', query: { tutorId: this.tutorId } }
        }
        return this.$router.push(route)
      }
      // 面对面扫码分享展示
      if (way === 'qrcode') {
        this.isShowContentPopup = true
        return
      }
      this.$refs.handleShare.handleShare(way)
      this.hidePanel()
    },
    /**
     * 关闭 分享内容弹窗
     * 二维码图片。
     */
    closeContentPopup () {
      this.isShowContentPopup = false
      this.$xesLogger.clickMsg({ params: { action: 'closeContentPopup', clickid: 'TODO' } })
    }
  }
}
</script>

<style lang="less" scoped>
.sharePanel {
  width: 100%;
  background-color: #fff;
  border-radius: 6px 6px 0 0;

  .sharePanel-main {
    padding: 20px 36px;

    .sharePanel-title {
      margin-bottom: 14px;
      font-size: 11px;
      font-weight: 400;
      color: #871e20;
    }

    .sharePanel-ways {
      .sharePanel-list {
        display: flex;
        justify-content: space-around;

        .sharePanel-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;

          div {
            width: 45px;
            height: 45px;
            background-size: 100%;
            background-repeat: no-repeat;
          }

          p {
            margin-top: 5px;
            font-size: 10px;
            color: #a0a0a0;
          }

          &-wechat > div {
            width: 53px;
            height: 46px;
            background-image: url("../assets/images/wechat.png");
          }

          &-timeline > div {
            background-image: url("../assets/images/timeline_2x.png");
          }

          &-qq > div {
            background-image: url("../assets/images/qq_2x.png");
          }

          &-poster > div {
            background-image: url("../assets/images/img.png");
          }

          &-qrcode > div {
            background-image: url("../assets/images/scan.png");
          }
        }
      }
    }

    .sharePanel-cancel {
      width: 180px;
      height: 30px;
      margin: 13px auto 0;
      font-size: 15px;
      font-weight: 500;
      line-height: 30px;
      color: #fff;
      background: linear-gradient(180deg, #fd6053 0%, #e02727 100%);
      border-radius: 15px;
    }
  }
  // ## 面对面扫码弹层
  .sharePanel-popup {
    width: 247px;
    padding: 33px 0;
    font-size: 15px;
    text-align: center;
    color: #333;
    border-radius: 6px;

    &-close {
      position: absolute;
      top: 15px;
      right: 12px;
      width: 10px;
      height: 10px;
      background: url("../assets/images/close.png") no-repeat;
      background-size: 100%;
    }

    & > h3 {
      font-size: 18px;
      font-weight: 500;
    }

    & > p {
      margin: 19px 0 37px;
    }

    & > img {
      width: 125px;
    }
  }
  // ## 链接分享遮罩
  .sharePanel-WSMask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    transform: unset;

    & > img {
      position: absolute;
      top: 20px;
      right: 42px;
      width: 274px;
    }
  }
}

</style>
